import { createClient } from '@supabase/supabase-js';

// Assegure-se de definir estas variáveis no seu ambiente de build ou .env
// Ex: SUPABASE_URL=https://seu-projeto.supabase.co
// Ex: SUPABASE_KEY=sua-chave-anon-publica

// Usando as credenciais fornecidas como fallback
const supabaseUrl = process.env.SUPABASE_URL || 'https://gluxgmluquvonidaxzuv.supabase.co';
const supabaseKey = process.env.SUPABASE_KEY || 'sb_publishable_Vz0oVF2i_fthkamV92lwVQ_R-f6zZvw';

// Flag to check if we have valid configuration
const isUrlValid = supabaseUrl && supabaseUrl !== 'https://placeholder.supabase.co';
const isKeyValid = !!supabaseKey;

// Removemos a verificação de JWT (ponto na string) pois a chave 'sb_publishable' 
// fornecida não segue o formato JWT padrão, mas deve ser aceita para tentar a conexão.
export const isSupabaseConfigured = isUrlValid && isKeyValid;

if (!isSupabaseConfigured) {
  console.warn('Supabase credentials not found. Using offline mode.');
}

export const supabase = createClient(supabaseUrl, supabaseKey);